import { Region } from '@enums/RegionList';
import { AvailableType } from '../../module/types/deliveryTypes';

interface DeliveryConfig {
  [key: number]: number;
}

export const delivery: DeliveryConfig = {
  [Region.Kostroma]: 3,
  [Region.Tver]: 2,
  [Region.Lipetsk]: 3,
  [Region.Obninsk]: 2,
  [Region.SergievPosad]: 2,
  [Region.Orel]: 2,
  [Region.Penza]: 3,
  [Region.Bryansk]: 2,
  [Region.Smolensk]: 2,
  [Region.Saransk]: 3,
  [Region.Elets]: 4,
  [Region.Klin]: 2,
  [Region.Rzhev]: 2,
};

export const deliveryStatus: DeliveryConfig = {
  [Region.Kostroma]: AvailableType.PickUpInThreeDays,
  [Region.Tver]: AvailableType.PickUpInTwoDays,
  [Region.Lipetsk]: AvailableType.PickUpInThreeDays,
  [Region.Obninsk]: AvailableType.PickUpInTwoDays,
  [Region.SergievPosad]: AvailableType.PickUpInTwoDays,
  [Region.Orel]: AvailableType.PickUpInTwoDays,
  [Region.Penza]: AvailableType.PickUpInThreeDays,
  [Region.Bryansk]: AvailableType.PickUpInTwoDays,
  [Region.Smolensk]: AvailableType.PickUpInTwoDays,
  [Region.Saransk]: AvailableType.PickUpInThreeDays,
  [Region.Elets]: AvailableType.PickupInFourDays,
  [Region.Klin]: AvailableType.PickUpInTwoDays,
  [Region.Rzhev]: AvailableType.PickUpInTwoDays,
};
